<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content">
      <img :src="data.icon" class="red-packet1-img"/>
      <template v-if="type===1">
        <p class="title">最长30天免息券任性领</p>
        <nd-button class="withdraw" @click="handleTextButtonClick(data.url)"
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 新年活动
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >试试手气</nd-button>
        <div class="activity-detail" @click="handleTextButtonClick(data.url)">
          活动详情 >
        </div>
      </template>
      <template v-else-if="type===2">
        <p class="title">恭喜您获得{{data.discountValue|isEmpty}}免息红包</p>
        <nd-button class="withdraw" @click="handleButtonClick"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 新年活动
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >惊喜提现</nd-button>
        <div class="activity-detail">
          红包激活有效期至{{ data.couponEndTime | date('YYYY/MM/DD') }}
        </div>
      </template>
      <template v-else-if="type===73">
        <nd-button class="withdraw"
                   data-sensors-click 
                   :class="`caseId-73`"
                   @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 尊享版
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >立即领取</nd-button>
        <div class="activity-detail" @click="close">
          不想省钱了
        </div>
      </template>
      <template v-else-if="type===96">
        <nd-button class="withdraw" @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 限额已满
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >立享提现特权</nd-button>
      </template>
      <template v-else-if="type===97">
        <p class="yzd-title">{{data.discountValue}}<span class="sort-money">元</span></p>
        <nd-button class="withdraw" @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 颜值贷
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >立即使用</nd-button>
        <div class="activity-detail" @click="close">
          放弃
        </div>
      </template>
      <template v-else-if="type===98">
        <nd-button class="withdraw" @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 秒杀
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >立即抢</nd-button>
        <div class="activity-detail" @click="close">
          放弃
        </div>
      </template>
      <template v-else-if="94">
        <p class="money" v-if="data.discountValue">提额{{data.discountValue}}元</p>
        <nd-button class="withdraw" @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 清享版
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >{{type|dealTitle}}</nd-button>
        <div class="activity-detail" @click="close">
          不想省钱了
        </div>
      </template>
      <template v-else>
        <nd-button class="withdraw"
                   :class="`caseId-${type}`"
                   data-sensors-click 
                   @click="handleTextButtonClick(data.url)"  
                   v-stat="{
                     id: 50022,
                     args: {
                       target: data.activeType, // 清享版
                       step: data.nextStep,
                       position: 2,
                       status: 1,
                       caseId:data.caseId
                     },
                   }"
        >{{type|dealTitle}}</nd-button>
        <div class="activity-detail" @click="close">
          不想省钱了
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number,
      default: 1
    }
  },
  filters: {
    isEmpty (value) {
      return value ? `${value}天` : ''
    },
    dealTitle (index) {
      let value = '立享特权'
      if ([93].includes(index)) {
        value = '立享礼包'
      } else if ([94].includes(index)) {
        value = '提额特权'
      } else if ([97].includes(index)) {
        value = '立即使用'
      }
      return value
    }
  },
  watch: {

  },
  methods: {
    handleTextButtonClick (url) {
      if (url) {
        this.$emit('close')
        let curUrl = url.replace(/^http[s]?:\/\/tmd.+?\//, `${window.location.origin}/`)
        window.location.href = curUrl
      }
    },
    close () {
      this.visible = false
      this.$report({
        id: 50021,
        args: {
          visible: 0,
          target: this.data.activeType,
          step: this.data.nextStep,
          status: 1,
          caseId: this.data.caseId
        }
      })
      this.$emit('close')
    },
    handleButtonClick () {
      this.$emit('close')
      this.$router.push({
        path: '/withdraw/index'
      })
    },
    show () {
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: this.data.activeType,
          step: this.data.nextStep,
          status: 1,
          caseId: this.data.caseId
        }
      })
      setKey(`newYear${this.type}`, Date.now())
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        position: relative;
        background-size: 100%;
        .money{
            position: absolute;
            top:243px;
            z-index:2;
            text-align: center;
            font-size: 56px;
            width:100%;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF4633;
            line-height: 78px;
        }
        .sort-money{
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFF1B7;
            line-height: 33px;
            padding-left:14px;
        }
        .yzd-title{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            z-index:2;
            top:240px;
            z-index:1111;
            font-size: 130px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #FFF1B7;
            line-height: 157px;
            width: 100%;
            margin: auto;
            text-align: center;
        }
        .title{
            position:absolute;
            width:100%;
            text-align: center;
            top:280px;
            left: 50%;
            transform: translateX(-50%);
            z-index:2;
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 45px;
        }
        .red-packet1-img{
            width: 620px;
            height: 750px;
            border-radius: 30px;
            position: absolute;
            background-size: 100%;
            z-index: 1;
        }
        .activity-detail {
            position: absolute;
            z-index: 2;
            bottom: 0px;
            left: 0px;
            right: 0px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 53px;
        }
        .withdraw {
            position: absolute;
            z-index:2;
            display: flex;
            justify-content: space-around;
            top: 540px;
            width: 440px;
            height: 80px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
        }
    }
}
</style>
